import useDistrictUrls from 'app/hooks/useDistrictUrls';
import { useDispatch } from 'react-redux';
import { handleChangedDistrict } from 'app/actions/sessionActions';
import { LinkOnComponent } from 'app/components/links/link';
import { COLORS, List, SIZES } from '@fupa/fupa-uikit';
import React, { useCallback } from 'react';
import styled from 'styled-components';
const DistrictList = styled(List).withConfig({
  componentId: "sc-1oxebmx-0"
})(["padding-left:", ";"], SIZES['52']);
var ReferrerType = /*#__PURE__*/function (ReferrerType) {
  ReferrerType["MATCHES"] = "matches";
  ReferrerType["COMPETITIONS"] = "competitions";
  ReferrerType["MARKETPLACE"] = "marketplace";
  ReferrerType["TRANSFERS"] = "transfers";
  return ReferrerType;
}(ReferrerType || {});
const URL_MAP = {
  [ReferrerType.MATCHES]: urls => urls.districtMatchesUrl,
  [ReferrerType.COMPETITIONS]: urls => urls.districtCompetitionsUrl,
  [ReferrerType.MARKETPLACE]: urls => urls.districtMarketplaceUrl,
  [ReferrerType.TRANSFERS]: urls => urls.districtTransfersUrl
};
const getDistrictUrl = (districtUrls, referrer) => {
  const referrerType = referrer;
  const urlMapper = URL_MAP[referrerType];
  return urlMapper ? urlMapper(districtUrls) : districtUrls.districtMainUrl;
};
const handleDistrictUpdate = (dispatch, district) => {
  const {
    brandings,
    ivw_st_desktop,
    ivw_st_mobil,
    ivw_dns_desktop,
    ivw_dns_mobil,
    ivw_cp_prefix,
    ...districtData
  } = district;
  handleChangedDistrict(dispatch, districtData, brandings, ivw_st_desktop, ivw_st_mobil, ivw_dns_desktop, ivw_dns_mobil, ivw_cp_prefix);
};
const DistrictLink = _ref => {
  let {
    district,
    referrer
  } = _ref;
  const districtUrls = useDistrictUrls(district.slug);
  const dispatch = useDispatch();
  const navigationUrl = getDistrictUrl(districtUrls, referrer);
  const handleClick = useCallback(() => handleDistrictUpdate(dispatch, district), [dispatch, district]);
  return /*#__PURE__*/React.createElement(LinkOnComponent, {
    enablehover: true,
    hovercolor: COLORS.lightGrey,
    to: navigationUrl,
    key: district.slug,
    onClick: handleClick,
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-component": "DistrictLink",
    "data-sentry-source-file": "DistrictLink.tsx"
  }, /*#__PURE__*/React.createElement(DistrictList, {
    "data-sentry-element": "DistrictList",
    "data-sentry-source-file": "DistrictLink.tsx"
  }, district.name));
};
export default DistrictLink;